import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './EmptyPanel.module.css';

type Props = {
  title: string;
  description: string;
  actionLabel?: string;
  actionTo?: string;
  children?: ReactNode;
};

export function EmptyPanel({ title, description, actionLabel, actionTo, children }: Props) {
  return (
    <div className={styles.panel}>
      <div className={styles.icon} aria-hidden>
        ∅
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.desc}>{description}</p>
      {actionLabel && actionTo ? (
        <Link className={styles.action} to={actionTo}>
          {actionLabel}
        </Link>
      ) : null}
      {children}
    </div>
  );
}
